module.exports = __webpack_public_path__ + "img/miandian.d3930bc5.jpg";